import { Box, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import { redesignOrderDetailsCheckboxControlSx, redesignOrderDetailsFormControlLabelSx } from "./redesignStyles";

interface RedesignOrderDetailsProps {
  maxAmount: number | null;
  availableForOrder: boolean;
  allowSpecialRequests: boolean;
  onChangeMaxAmount: (maxAmount: number | null) => void;
  onChangeAvailableForOrder: (availableForOrder: boolean) => void;
  onChangeAllowSpecialRequests: (allowSpecialRequests: boolean) => void;
  variant: "MenuItem" | "MenuItemAppearance" | "RestaurantLinkMenuItemAppearance";
}

/** Figma Order Details card — Kitchen menu item redesign only. Legacy uses `Details.tsx`. */
export const RedesignOrderDetails = ({
  maxAmount,
  availableForOrder,
  allowSpecialRequests,
  variant,
  onChangeMaxAmount,
  onChangeAvailableForOrder,
  onChangeAllowSpecialRequests,
}: RedesignOrderDetailsProps) => {
  const handleSetAvailableForOrder = (nextAvailableForOrder: boolean) => {
    onChangeAvailableForOrder(nextAvailableForOrder);
    if (!nextAvailableForOrder) {
      onChangeAllowSpecialRequests(false);
    }
  };

  const availableLabel = variant === "MenuItem" ? "Available for order (Default)" : "Available for order";
  const specialRequestsLabel = variant === "MenuItem" ? "Allow special requests (Default)" : "Allow special requests";
  const limitLabel = variant === "MenuItem" ? "Default limit servings per order" : "Limit servings per order";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h4">Order Details</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <FormControlLabel
          label={availableLabel}
          disabled={variant === "RestaurantLinkMenuItemAppearance"}
          control={
            <Checkbox
              size="small"
              checked={availableForOrder}
              onChange={e => handleSetAvailableForOrder(e.target.checked)}
              sx={redesignOrderDetailsCheckboxControlSx}
            />
          }
          sx={redesignOrderDetailsFormControlLabelSx}
        />
        <FormControlLabel
          label={specialRequestsLabel}
          control={
            <Checkbox
              size="small"
              checked={allowSpecialRequests}
              onChange={e => onChangeAllowSpecialRequests(e.target.checked)}
              disabled={!availableForOrder}
              sx={redesignOrderDetailsCheckboxControlSx}
            />
          }
          sx={redesignOrderDetailsFormControlLabelSx}
        />
        <FormControlLabel
          label={limitLabel}
          control={
            <Checkbox
              size="small"
              checked={maxAmount !== null}
              onChange={e => onChangeMaxAmount(e.target.checked ? 1 : null)}
              sx={redesignOrderDetailsCheckboxControlSx}
            />
          }
          sx={redesignOrderDetailsFormControlLabelSx}
        />
        {maxAmount !== null && (
          <TextField
            label="Max amount"
            type="number"
            inputProps={{ min: 1 }}
            sx={{ width: 160, height: 48, mt: 2 }}
            value={maxAmount}
            onChange={e => onChangeMaxAmount(parseInt(e.target.value))}
            error={isNaN(maxAmount)}
          />
        )}
      </Box>
    </Box>
  );
};
